import React from "react";
import { Box, Slider } from "@mui/material";

function ProgressBar({ currentStep, sx }) {
  const getStepValue = (step) => {
    switch (step) {
      case "PASO 1":
        return 33;
      case "PASO 2":
        return 66;
      case "PASO 3":
        return 100;
      default:
        return 0;
    }
  };

  const getStepColor = (step, targetStep) => {
    return step === targetStep ? "#00DBDC" : "#2C2C2C";
  };

  const sliderValue = getStepValue(currentStep);

  return (
    <>
      <Box sx={{ width: "200px", margin: 0, padding: 0, ...sx }}>
        <Box sx={{ maxWidth: "100%" }}>
          <Slider
            size="small"
            value={sliderValue}
            aria-label="Small"
            valueLabelDisplay="off"
            sx={{
              margin: 0,
              padding: 0,
              color: "#00DBDC",
              "& .MuiSlider-track": {
                color: "#00DBDC",
              },
              "& .MuiSlider-thumb": {
                color: "#00DBDC",
              },
              "& .MuiSlider-rail": {
                color: "#2C2C2C",
              },
              "@media (max-width: 600px)": {
                margin: 0,
                padding: 0,
              },
              ...sx,
            }}
          />
          <Box
            sx={{
              width: "100%",
              margin: 0,
              display: "flex",
              justifyContent: "space-between",
              ...sx,
            }}
          >
            <p
              style={{
                fontSize: "13px",
                fontWeight: "500",
                color: getStepColor("PASO 1", currentStep),
              }}
            >
              PASO <span className="special-font">1</span>
            </p>
            <p
              style={{
                fontSize: "13px",
                fontWeight: "500",
                color: getStepColor("PASO 2", currentStep),
              }}
            >
              PASO <span className="special-font">2</span>
            </p>
            <p
              style={{
                fontSize: "13px",
                fontWeight: "500",
                color: getStepColor("PASO 3", currentStep),
              }}
            >
              PASO <span className="special-font">3</span>
            </p>
          </Box>
        </Box>
      </Box>
    </>
  );
}

export default ProgressBar;
